import { sort } from 'ramda'

const sortStrings = array => sort((a, b) => a.localeCompare(b), array)

export default sortStrings
